import { DateTime } from 'luxon';
import { REGIONS } from '../../constants/region.constants';
import { isToday } from '../../utils/date.utils';
import { AUTH_USER_TYPE_NORMAL, AUTH_USER_TYPE_MAGIC_LINK } from '../../constants';

export const getUser = ({ auth }) => {
  let { user } = auth;

  return user;
};

/**
 * Resolve the authenticated user's id from the auth slice, mirroring the
 * canonical fallback chain used elsewhere (see AuthService.refreshToken).
 * The id is not always present on the user object — early in the sign-in flow
 * and in the biometric-unlock/cold-start state it lives on the top-level
 * `auth.id` instead. Falling through these keeps analytics identity correct.
 * @param {{ auth: object }} state
 * @returns {string | null}
 */
export const getUserId = ({ auth }) =>
  auth?.user?.id || auth?.id || auth?.refreshTokenDetails?.id || null;

export const getRegion = ({ auth }) => {
  return auth.region ?? REGIONS.US;
};

export const isProfileMandatory = ({ auth, generalConfig }) => {
  const { user } = auth;
  const mandatoryDate = DateTime.fromISO(generalConfig.USER_PROFILE_MANDATORY_DATE);
  const userCreatedAt = DateTime.fromISO(user.createdAt);

  return generalConfig.USER_PROFILE_MANDATORY_DATE && userCreatedAt >= mandatoryDate;
};

export const needToUpdateProfile = state => {
  const { user } = state.auth;

  if (!isNormalUser(state)) return false;

  return (
    (isProfileMandatory(state) && user?.profileCompletedAt === null) ||
    (user?.profileCompletedAt === null && !isToday(user?.snooze?.lastCheck))
  );
};

export const canSnoozeProfileUpdate = ({ auth }) => {
  const { user } = auth;
  return user?.snooze?.counter < 5;
};

export const isNormalUser = ({ auth }) => {
  const { user } = auth;
  return user?.type === AUTH_USER_TYPE_NORMAL;
};

export const isMagicLinkUser = ({ auth }) => {
  const { user } = auth;
  return user?.type === AUTH_USER_TYPE_MAGIC_LINK;
};
